import { render, staticRenderFns } from "./DlgAnimalsEdit.vue?vue&type=template&id=7ba3d219&scoped=true&"
import script from "./DlgAnimalsEdit.vue?vue&type=script&lang=ts&"
export * from "./DlgAnimalsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba3d219",
  null
  
)

export default component.exports